import { apiClient, getAuthToken } from "../../api/client";
import {
  parseAirshowJunctionPreviewResponse,
  type AirshowJunctionPreviewRequest,
  type AirshowJunctionPreviewResponse,
} from "./airshowJunctionContract";

const ARTIFACT_URL = /^\/api\/thread\/v1\/projects\/[^/]+\/aero\/vsp\/airshow\/junction-previews\/[a-f0-9]{64}\/(?:baseline\.gltf|result\.gltf|metadata\.json)$/;

export async function requestAirshowJunctionPreview(input: {
  projectId: string;
  request: AirshowJunctionPreviewRequest;
  signal?: AbortSignal;
}): Promise<AirshowJunctionPreviewResponse> {
  if (!input.projectId.trim()) throw new Error("Airshow junction preview requires a project identity");
  const response = await apiClient<unknown>(
    `/thread/v1/projects/${encodeURIComponent(input.projectId)}/aero/vsp/airshow/junction-previews`,
    { method: "POST", signal: input.signal, body: input.request },
  );
  return parseAirshowJunctionPreviewResponse(response, {
    projectId: input.projectId,
    request: input.request,
  });
}

export async function fetchAirshowJunctionArtifact(
  artifactUrl: string,
  signal?: AbortSignal,
): Promise<unknown> {
  if (!ARTIFACT_URL.test(artifactUrl)) {
    throw new Error("Airshow junction artifact URL must be a bound same-origin /api path");
  }
  const token = await getAuthToken();
  const response = await fetch(artifactUrl, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    signal,
  });
  if (!response.ok) throw new Error(`Airshow junction artifact failed (${response.status})`);
  return response.json() as Promise<unknown>;
}
